import { render } from "./NewsFilter.vue?vue&type=template&id=f1682f88&scoped=true"
import script from "./NewsFilter.vue?vue&type=script&lang=js"
export * from "./NewsFilter.vue?vue&type=script&lang=js"

import "./NewsFilter.vue?vue&type=style&index=0&id=f1682f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1682f88"]])

export default __exports__